import { useTranslation } from 'react-i18next';
import { FunctionComponent } from 'react';
import { Tabs, TabsProps } from 'antd';

// services
import { isRTL } from 'core/services/language';

// components
import ProfileDataComponent from '../components/profileData';
import ProfileChangePasswordComponent from './../components/changePassword';
import PageTitle from 'components/title/title';

const BusinessProfilePage: FunctionComponent = () => {
	const { t } = useTranslation();

	const tabItems: TabsProps['items'] = [
		{
			key: 'upload',
			label: t('PROFILE.PROFILE'),
			destroyInactiveTabPane: true,
			children: <ProfileDataComponent />,
		},
		{
			key: 'review',
			label: t('PROFILE.CHANGE_PASSWORD'),
			destroyInactiveTabPane: true,
			children: <ProfileChangePasswordComponent />,
		},
	];

	return (
		<>
			<PageTitle name={t('TITLE.PROFILE')} />

			<Tabs defaultActiveKey="1" items={tabItems} size="large" direction={isRTL() ? 'rtl' : 'ltr'} />
		</>
	);
};

export default BusinessProfilePage;
